module.exports = __webpack_public_path__ + "static/media/04.a16ac57a.jpg";